import { Modal, MODAL_SIZES } from 'components/ModalV2';
import { useLocationConsent } from 'hooks';
import { useTranslation } from 'react-i18next';
import { DropOffCard } from '../../../../../../DropOffCard';
import { DropOffDescriptionContainer } from './DropOffDescriptionContainer.styles';

export const DropOffDetailModal = ({ dropOff, isOpen, onClose }) => {
  const { t } = useTranslation();
  const { isAllowGoogleMaps } = useLocationConsent();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={isAllowGoogleMaps ? MODAL_SIZES.lg : MODAL_SIZES.sm}
      closable
      aria={{
        labelledby: 'drop-off-detail-modal-heading',
      }}
    >
      <Modal.Header id="drop-off-detail-modal-heading">
        {t('RETURN_PARCEL_DROPOFF_LOCATION')}
      </Modal.Header>
      <Modal.Body>
        <DropOffDescriptionContainer
          isFullWidth
          justify="space-between"
          direction="column"
        >
          <DropOffCard
            dropOff={dropOff}
            expanded
            isViewOnly
            isShowDropoffMap={isAllowGoogleMaps}
          />
        </DropOffDescriptionContainer>
      </Modal.Body>
    </Modal>
  );
};
